import { getFixedT } from '@app/core/i18n';

const t = getFixedT(null, null);

export const FileSizes = [
  t('attachment.bytes|Bytes label', 'Bytes'),
  t('attachment.kb|Kb label', 'KB'),
  t('attachment.mb|Mb label', 'MB'),
  t('attachment.gb|Gb label', 'GB'),
  t('attachment.tb|Tb label', 'TB'),
];

export function formatBytes(bytes: number, decimals: number = 2): string {
  if (!bytes) {
    return '';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${FileSizes[i]}`;
}
